import { MemberApis, memberClient } from "common/apis/member";
import SpinnerMedium from "components/Spinner/Medium";
import React, { useContext, useEffect, useState } from "react";
import { createContext } from "react";
import { toast } from "react-toastify";

type MemberAuthProps = {
    member: any;
    login: () => void;
    logout: () => void;
    reload: () => Promise<void>;
}

const MemberAuthContext = createContext<MemberAuthProps>({
    member: null,
    login: () => { },
    logout: () => { },
    reload: async () => { }
});

export const useMemberAuth = () => useContext(MemberAuthContext);

export const MemberAuthProvider = ({ children }) => {
    const [member, setMember] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        fetchMyInfo();
    }, []);

    const login = async ()=>{
        await fetchMyInfo();
        toast.success("로그인 되었습니다.");
    }

    const fetchMyInfo = async () => {
        try {
            const ret = await MemberApis.getMyInfo();
            console.log("[fetchMyInfo] ret", ret);
            setMember(ret);
        } catch (e) {
            console.error("[fetchMyInfo] error", e);
        }
        setIsLoaded(true);
    }

    if (!isLoaded) {
        return <SpinnerMedium />
    }

    return (
        <MemberAuthContext.Provider value={{
            member,
            login,
            logout: () => {
                setMember(null);
                toast.success("로그아웃 되었습니다.");
            },
            reload: fetchMyInfo
        }}>
            {children}
        </MemberAuthContext.Provider>
    )
}